<script lang="ts">
	import { serializeScriptValue } from "@fergmar/ui/script";
	import { Team, FAQ, FreeQuote } from "#lib/web-ui/home-buyers-template/content/index.js";
	import { getTemplateContext } from "#lib/web-ui/home-buyers-template/template-context.svelte.js";
	import { cloudinaryUrl } from "#lib/shared/cloudinary.js";
	import { page } from "$app/state";

	const templateContext = getTemplateContext();

	const pageUrl = $derived(`${templateContext.siteUrl.replace(/\/$/, "")}${page.url.pathname}`);
	const pageTitle = `Meet the Team - ${templateContext.siteName}`;
	const pageDescription = `Meet the experienced team at ${templateContext.siteName}. We're local home buyers serving ${templateContext.primaryCity} and ${templateContext.serviceArea}, dedicated to helping homeowners sell their houses fast with fair cash offers.`;

	const aboutPageJsonLd = $derived({
		"@context": "https://schema.org",
		"@type": "AboutPage",
		"@id": `${pageUrl}#webpage`,
		url: pageUrl,
		name: pageTitle,
		description: pageDescription,
		isPartOf: { "@id": `${templateContext.siteUrl}#website` },
		about: { "@id": `${templateContext.siteUrl}#organization` },
		inLanguage: "en-US",
		breadcrumb: {
			"@type": "BreadcrumbList",
			itemListElement: [
				{
					"@type": "ListItem",
					position: 1,
					name: "Home",
					item: templateContext.siteUrl
				},
				{
					"@type": "ListItem",
					position: 2,
					name: "Meet the Team",
					item: pageUrl
				}
			]
		}
	});
</script>

<svelte:head>
	<title
		>Meet the Team - {templateContext.siteName} | Local Home Buyers in {templateContext.primaryCity},
		{templateContext.primaryState}</title
	>
	<meta
		name="description"
		content="Meet the experienced team at {templateContext.siteName}. We're local home buyers serving {templateContext.primaryCity} and {templateContext.serviceArea}, dedicated to helping homeowners sell their houses fast with fair cash offers."
	/>

	<!-- Open Graph -->
	<meta property="og:type" content="website" />
	<meta
		property="og:title"
		content="Meet the Team - {templateContext.siteName} | Local Home Buyers in {templateContext.primaryCity}, {templateContext.primaryState}"
	/>
	<meta
		property="og:description"
		content="Meet the experienced team at {templateContext.siteName}. We're local home buyers serving {templateContext.primaryCity} and {templateContext.serviceArea}, dedicated to helping homeowners sell their houses fast with fair cash offers."
	/>
	<meta
		property="og:url"
		content="{templateContext.siteUrl.replace(/\/$/, '')}{page.url.pathname}"
	/>
	{#if templateContext.images?.teamHero}
		<meta
			property="og:image"
			content={cloudinaryUrl(templateContext.images.teamHero, { width: 1200 })}
		/>
	{/if}

	<svelte:element this={"script"} type="application/ld+json">
		{serializeScriptValue(aboutPageJsonLd)}
	</svelte:element>
</svelte:head>

<div class="sr-only">
	<h1>Meet the Team - {templateContext.siteName}</h1>
</div>

<Team />
<FreeQuote />
<FAQ />
